'use client';

import { useAuth } from '@/contexts';
import { AuthButton } from '@/widgets/Header/AuthButton';
import { Box } from '@mui/material';
import { useSession } from 'next-auth/react';

export const ProtectedLayout = ({ children }: { children: React.ReactNode }) => {
  const { user, isAuthenticated, isLoggingOut } = useAuth();
  const { status } = useSession();

  // Session is still resolving, or signOut from a dead refresh token is in
  // progress. A login click during that signOut overwrites the OAuth state cookie.
  if (status === 'loading' || isLoggingOut) return null;

  if (!isAuthenticated || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: '80px' }}>
        <AuthButton />
      </Box>
    );
  }

  return <>{children}</>;
};
